import { Route, Switch } from 'react-router-dom';
import Store from './Store.component';
import Details from './details/Details.component';

const Routes = () => {

  return (
    <Switch>
      <Route exact path="/loja" component={Store} />
      <Route path="/loja/:id" component={Details} />
      <Route path="/loja/dashboard" component={Details} />
      <Route component={() => <>NotFoundRedirect</>} />
    </Switch>
  );

}

export default Routes;

